import { createFileRoute } from '@tanstack/react-router'
import { PurchaseDetailPage } from '../../../../features/purchasing/purchase-detail-page'
import { documentActionSearchSchema } from '../../../../features/sales/document-action'

export const Route = createFileRoute('/_app/purchases/$purchaseId/')({
  validateSearch: documentActionSearchSchema,
  component: PurchaseDetailPage,
})
